export default __webpack_public_path__ + "static/media/Ies_MesasCruzadas_Mark_ACCESO_eng.ee5aae93.jpg";